import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import QRCode from "react-qr-code";
import StudentInfo from "../FeeSystem/StudentInfo";
import moment from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { calculateColumnTotal, getMonthName } from "../General/Utility";
const PrintRoutesReportDetail = () => {
    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(
        localStorage.getItem("MemberType")
    );
    const [loading, setLoading] = useState(false);
    const [listOfLedger, setLedger] = useState([]);
    const [ReportMonth, setReportMonth] = useState("");
    const [ReportYear, setReportYear] = useState("");
    const [Wing, setWing] = useState("");
    const [Section, setSection] = useState("");
    const [SessionID, setSessionID] = useState("");
    const [Session, setSession] = useState("");
    const [Class, setClass] = useState("");
    const [RouteID, setRouteID] = useState("");

    // pagination
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [TotalAmount, setTotalAmount] = useState(0);

    useEffect(() => {
        document.title = "AGS School Management System";

        setLoading(true);
        // Get the URL parameters
        const urlParams = new URLSearchParams(window.location.search);

        // Retrieve individual parameter values
        const ReportYear = urlParams.get("ReportYear");
        const ReportMonth = urlParams.get("ReportMonth");
        const Wing_Id = urlParams.get("Wing");
        const Class_Id = urlParams.get("Class");
        const Section_Id = urlParams.get("Section");
        const Route_Id = urlParams.get("RouteID");
        const RouteCode = urlParams.get("RouteCode")
        setReportYear(ReportYear);
        setReportMonth(ReportMonth);

        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            pageNo: 1,
            pageSize: 100000,
            ReportYear: ReportYear,
            ReportMonth: ReportMonth,
            Wing_Id: Wing,
            Class_Id: Class,
            Section_Id: Section,
            AccountLevel: RouteID,
            Registration_No: RouteCode
        };

        //console.log(data);

        var api_config = {
            method: "post",
            url: config.base_url + "/Reports/GetRoutesReportDetails",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        //console.log(data);
        axios(api_config)
            .then(function (response) {
                //console.log(response.data);
                setLedger(response.data.ListofRecords);
                setLoading(false);
                setTotalRecords(response.data.totalRecords);
                setTotalAmount(response.data.TotalAmount);
            })
            .catch(function (error) {
                //console.log(error);
            });
    }, []);

    const renderLedger = () => {
        if (listOfLedger != null && listOfLedger.length > 0) {
            return listOfLedger.map((item, index) => {
                return (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.Selected_Student.Registration_No}</td>
                        <td>{item.Selected_Student.Student_Name}</td>
                        <td>{item.Selected_Student.Contact_Email} - {item.Selected_Student.Contact_Phone}</td>
                        <td>{item.Selected_Student.Bay_Form_No}</td>
                        <td>{item.Fee_Posted}</td>
                        <td>{item.ConcessionAmount}</td>
                        <td>{item.ReceiveableFee}</td>
                        <td>{item.ReceivedAmount}</td>
                        <td>{item.PendingFee}</td>
                    </tr>
                );
            });
        } else {
            return (
                <tr>
                    <td colSpan="10">
                        <h4
                            className="mt-3"
                            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
                        >
                            No Data Found
                        </h4>
                    </td>
                </tr>
            );
        }
    };

    return (
        <>
            <Page orientation="portrait" size="a4">
                <table className="table table-sm table-bordered table-print">
                    <thead>
                        <tr>
                            <th colSpan={7}>
                                <PrintHeader
                                    title={`Routes Report for the month of ${getMonthName(
                                        ReportMonth
                                    )} ${ReportYear} `}
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td className="text-center" colSpan="6">
                                    <Spinner animation="border" role="status"></Spinner>
                                </td>
                            </tr>
                        ) : (
                            <>
                                <tr>
                                    <th>Serial No</th>
                                    <th>Registration No</th>
                                    <th>Student Name</th>
                                    <th>Class</th>
                                    <th>Bus Route</th>
                                    <th>Fee Posted</th>
                                    <th>Concession</th>
                                    <th>Receiveable</th>
                                    <th>Received</th>
                                    <th>Pending</th>
                                </tr>
                                {renderLedger()}
                                <tr>
                                    <th colSpan={5}>Total Amount :</th>
                                    <th className="">
                                        {calculateColumnTotal(listOfLedger, "Fee_Posted")}
                                    </th>
                                    <th className="">
                                        {calculateColumnTotal(listOfLedger, "ConcessionAmount")}
                                    </th>
                                    <th className="">
                                        {calculateColumnTotal(listOfLedger, "ReceiveableFee")}
                                    </th>
                                    <th className="">
                                        {calculateColumnTotal(listOfLedger, "ReceivedAmount")}
                                    </th>
                                    <th className="">
                                        {calculateColumnTotal(listOfLedger, "PendingFee")}
                                    </th>
                                </tr>
                            </>
                        )}
                    </tbody>
                </table>
            </Page>
        </>
    );
};

export default PrintRoutesReportDetail;